import {
	Action,
	combineReducers,
	configureStore,
	getDefaultMiddleware
} from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import thunkMiddleware, { ThunkAction, ThunkDispatch } from 'redux-thunk';
import {
	persistStore,
	persistReducer,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authSlice from './slices/authSlice';
import geofenceSlice from './slices/geofenceSlice';
import holidaySlice from './slices/holidaySlice';
import rolePermissionSlice from './slices/rolePermissionSlice';
import appSettingSlice from './slices/appSettingSlice';
import timeSloteSlice from './slices/timeSloteSlice';
import contactUsSlice from './slices/contactUsSlice';
import notificationSlice from './slices/notificationSlice';
import productSlice from './slices/productSlice';
import orderSlice from './slices/orderSlice';
import mapSlice from './slices/mapSlice';
import reportSlice from './slices/reportSlice';
import emailTemplatesSlice from './slices/emailTemplatesSlice';
import cmsSlice from './slices/cmsSlice';
import subAdminSlice from './slices/subAdminSlice';

import vendorSlice from './slices/vendorSlice';
import userSlice from './slices/userSlice';
import driverSlice from './slices/driverSlice';
import settlementSlice from './slices/settlementSlice';
import subscriptionplanSlice from './slices/subscriptionplanSlice';
import paymentSlice from './slices/paymentSlice';
const authPersistConfig = {
	key: 'auth',
	storage,
	whitelist: [''] // Specify the fields you want to persist within the auth slice
};

const rootReducer = combineReducers({
	// geofence13: persistReducer(authPersistConfig, geofenceSlice), // example if we want to persist any slice
	auth: authSlice,
	geofence: geofenceSlice,
	holiday: holidaySlice,
	rolePermission: rolePermissionSlice,
	appSetting: appSettingSlice,
	timeslote: timeSloteSlice,
	contactUs: contactUsSlice,
	notification: notificationSlice,
	subAdmin: subAdminSlice,
	product: productSlice,
	order: orderSlice,
	map: mapSlice,
	report: reportSlice,
	email: emailTemplatesSlice,
	cms: cmsSlice,
	users: userSlice,
	vendor: vendorSlice,
	driver: driverSlice,
	settlement: settlementSlice,
	subscriptionplan: subscriptionplanSlice,
	payment: paymentSlice,
	// auth : authSlice
	// Add other reducers if needed
});

const store = configureStore({
	reducer: rootReducer,
	devTools: true,
	middleware: [
		...getDefaultMiddleware({
			serializableCheck: {
				// this is due to error in console ==> error due to  getDefaultMiddleware getting depreciated
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
			}
		}),
		thunkMiddleware
	]
});

export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type Dispatch = ThunkDispatch<RootState, undefined, Action>;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const persistor = persistStore(store);

export const { dispatch: DISPATCH }: any = store;

export default store;
